import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    current: 'light',
};
const themeSlice = createSlice({
    name: 'theme',
    initialState,
    reducers: {
        setTheme: (state, action) => {
            // Validate that the theme is one of the allowed themes
            const validThemes = ['light', 'dark', 'mellowYellow', 'purpleRain', 'blueSky', 'system'];
            if (validThemes.includes(action.payload)) {
                state.current = action.payload;
            }
            else {
                console.warn(`Invalid theme: ${action.payload}, using light theme instead`);
                state.current = 'light';
            }
        },
    },
});
export const { setTheme } = themeSlice.actions;
export default themeSlice.reducer;
